import { API, createPath } from "../helpers"
import { NETLIFY_URL } from "./constants"
import { Include } from "./orders"

export const validateAddress = async (address: any) =>
  API.post(`${NETLIFY_URL}/validate-address`, {
    body: address,
  })

export const getOrderWithAddresses = async (orderId: string) =>
  API.get(
    createPath(`${NETLIFY_URL}/get-order`, {
      orderId,
      include: `${Include.ShippingAddress},${Include.BillingAddress}`,
    })
  )

export const validateVat = (vatNumber: string, countryCode: string) =>
  API.get(
    createPath(`${NETLIFY_URL}/is-vat-member`, { countryCode, vatNumber })
  )
